module.exports = __webpack_public_path__ + "static/media/z.57b03b88.svg";